module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-vip-white.7dc334cf.png";